module.exports = __webpack_public_path__ + "img/bijuli-bhawan-map.74d11dd6.png";